import type { CrmObject } from '@/types/crm';

import type { HighlightDefinition } from '../registry/entityTypeRegistry';
import { HighlightCardShell } from './HighlightCardShell';
import { ENTITY_COUNT_ICON } from './highlightIcons';
import { useHighlightEntityCount } from './useHighlightEntityCount';

interface EntityCountHighlightCardProps {
  object: CrmObject;
  definition: Extract<HighlightDefinition, { kind: 'entity_count' }>;
  orgId: number;
}

export function EntityCountHighlightCard({
  object,
  definition,
  orgId,
}: EntityCountHighlightCardProps) {
  const result = useHighlightEntityCount(orgId, object, definition);
  return (
    <HighlightCardShell
      label={definition.label}
      result={result}
      icon={ENTITY_COUNT_ICON}
    />
  );
}
